/**
 * /erm2026 — Índice de la sección ERM2026 (regional + municipal · 4-oct-2026)
 */
import { Link } from "react-router-dom";

const SUBSECCIONES = [
  {
    to: "/erm2026/jee",
    titulo: "Inscripción de listas (JEE)",
    detalle:
      "Material completo para organizaciones políticas, personeros y ciudadanía: guías, cuadros, normativa oficial JNE/ONPE, posts de difusión.",
    disponible: true,
  },
  {
    to: "/erm2026/cronograma",
    titulo: "Cronograma electoral",
    detalle: "Fechas clave del proceso ERM 2026 (próximamente).",
    disponible: false,
  },
  {
    to: "/erm2026/candidatos",
    titulo: "Candidatos por circunscripción",
    detalle:
      "Cuando se cierre la inscripción de listas, índice de candidatos por gobierno regional y municipio (próximamente).",
    disponible: false,
  },
];

export function Erm2026IndexPage() {
  return (
    <div className="container-prose py-12 md:py-16">
      <div className="flex flex-wrap items-center gap-2">
        <span className="chip-reconocido">🎯 ERM 2026</span>
        <span className="chip-vacio">⚫ Sección en construcción</span>
      </div>

      <h1 className="mt-6 font-serif text-4xl text-ink-50 md:text-5xl">
        Elecciones Regionales y Municipales 2026
      </h1>
      <p className="mt-3 text-xs uppercase tracking-widest text-gold-400/80">
        Jornada electoral · 4 de octubre de 2026
      </p>
      <p className="mt-4 max-w-3xl text-lg text-ink-200">
        El 4 de octubre de 2026 se renuevan en una sola jornada las autoridades de los 26 gobiernos
        regionales del país y de la totalidad de municipalidades provinciales y distritales. Esta
        sección reúne material no partidario para inscripción de listas, cronograma y, cuando
        cierre la inscripción, índice de candidaturas.
      </p>

      <div className="mt-10 grid gap-4 md:grid-cols-2">
        {SUBSECCIONES.map((s) =>
          s.disponible ? (
            <Link
              key={s.to}
              to={s.to}
              className="rounded-lg border border-gold-500/40 bg-gold-500/5 p-5 hover:bg-gold-500/10 transition"
            >
              <div className="flex items-center justify-between">
                <h2 className="font-serif text-xl text-ink-50">{s.titulo}</h2>
                <span className="text-xs text-gold-300">disponible →</span>
              </div>
              <p className="mt-2 text-sm text-ink-200">{s.detalle}</p>
            </Link>
          ) : (
            <div
              key={s.to}
              className="rounded-lg border border-ink-700/40 bg-ink-900/30 p-5 opacity-70"
            >
              <div className="flex items-center justify-between">
                <h2 className="font-serif text-xl text-ink-100">{s.titulo}</h2>
                <span className="text-xs text-ink-400">próximamente</span>
              </div>
              <p className="mt-2 text-sm text-ink-300">{s.detalle}</p>
            </div>
          )
        )}
      </div>
    </div>
  );
}
